<template>
	<Sizer
		:initFormData="defaultFormDataValues"
		:onResults="onResults"
	>
		<template v-slot:form-sections>
			<ERInputs v-if="sizerStore.userToggledERSizing" />

			<div :class="['fieldgroup', formData.sizeAdditionalER && 'disabled']">
				<CustomLoadInputs />

				<BuildingTypeSelect
					v-if="formData.customLoadMethod !== 'onlyCL'"
					:disabled="isCustomLoadEnabled"
				/>

				<CASpecToggle v-if="formData.buildingType === 'multi_family' && formData.customLoadMethod !== 'onlyCL'" />

				<MultifamilyOccupancyMethodToggle
					v-if="formData.buildingType === 'multi_family' && showOccupancyInputs"
				/>

				<OccupancyInputs v-if="showOccupancyInputs" />

				<SchematicSelect />

				<WaterTempInputs />

				<LoadShift />
			</div>
		</template>
	</Sizer>
</template>

<script>
import Sizer from '@/components/Sizer'
// Form section components
import ERInputs from '@/components/form-sections/ERInputs'
import BuildingTypeSelect from '@/components/form-sections/BuildingTypeSelect'
import CASpecToggle from '@/components/form-sections/CASpecToggle'
import MultifamilyOccupancyMethodToggle from '@/components/form-sections/MultifamilyOccupancyMethodToggle'
import CustomLoadInputs from '@/components/form-sections/CustomLoadInputs'
import OccupancyInputs from '@/components/form-sections/OccupancyInputs'
import WaterTempInputs from '@/components/form-sections/WaterTempInputs'
import SchematicSelect from '@/components/form-sections/SchematicSelect'
import LoadShift from '@/components/form-sections/LoadShift'
// data stores
import formData, { defaultFormDataValues } from '@/components/Sizer/form-data-store'
import sizerStore from '@/components/Sizer/sizer-store'

export default {
	name: 'BpaSizer',

	components: {
		Sizer,
		ERInputs,
		BuildingTypeSelect,
		CASpecToggle,
		MultifamilyOccupancyMethodToggle,
		CustomLoadInputs,
		OccupancyInputs,
		WaterTempInputs,
		SchematicSelect,
		LoadShift,
	},

	data: () => ({
		formData,
		sizerStore,
		changeFlag: undefined,
		defaultFormDataValues,
	}),

	computed: {
		isCustomLoadEnabled () {
			return this.formData.customLoadMethod !== 'ignCL'
		},

		showOccupancyInputs () {
			// Hide OccupancyInputs when using "Custom only" mode for multifamily
			if (
				this.formData.buildingType === 'multi_family' &&
				this.formData.customLoadMethod === 'onlyCL'
			) {
				return false
			}
			return true
		},
	},

	watch: {
		formData: {
			handler (newVal) {
				// This watcher is in charge of detecting whether the form data has been changed
				// from the last time the form was submitted for the purpose of enabling or disabling
				// ER sizing. The changeFlag logic here is simply an optimization so that we don't
				// check potentially every single form value every time anything changes. At it's base
				// case it just checks if any current values differ from last submitted values.
				const { changeFlag } = this
				const { lastSubmitData } = sizerStore

				if (
					lastSubmitData
					&& (
							!changeFlag ||
							formData[changeFlag] == lastSubmitData[changeFlag]
						)
				) {
					const [newFlag] = Object.entries(lastSubmitData).find(
						([key, value]) => value != newVal[key] && key !== 'sizeAdditionalER'
					) || []

					this.changeFlag = newFlag
					sizerStore.submitDataChanged = !!newFlag
				}
			},

			deep: true,
		},
		'formData.buildingType': function (newBuildingType) {
			if (newBuildingType !== 'multi_family') {
				this.formData.RLHLmethod = 'Recirculation Loop';
			}
		},

		'formData.customLoadMethod': function (newMethod) {
			// Lock building type to multi_family when custom load is enabled
			if (newMethod !== 'ignCL') {
				this.formData.buildingType = 'multi_family'
			}
		}
	},

	created () {
		if (!sizerStore.out) {
			this.$router.replace('/sizer-bpa/')
		}
	},

	methods: {
		onResults ({ success }) {
			const { $router: { push } } = this

			if (success) {
				sizerStore.lastSubmitData = { ...formData }
				sizerStore.submitDataChanged = false
				this.changeFlag = undefined

				push('/sizer/size')
			} else {
				scrollTo({ top: 0, behavior: 'smooth' })
			}

		}
	},
}
</script>
